import React from 'react';
import {connect} from 'react-redux';
import ButtonBase from '../../Buttons/ButtonBase';
import CardBenefit from '../../Cards/CardBenefit/index';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import './index.scss';
import BillingIcon from '../../Icons/BillingIcon';
import MembershipPremium from '../../MembershipsCards/MembershipPremium';
import MembershipCard from '../../MembershipsCards/MembershipCard';
import MFirmsLp from '../../Memberships/MFirmsLp';
import MLawyersDb from '../../Memberships/MLawyersDb';
import MFirmsDb from '../../Memberships/MFirmsDb';
import moment from 'moment';
const getButtonTitle = (membershipName) => {
  let title;
  switch (membershipName) {
    case 'free':
      title = '¡Quiero mejorar mi plan!';
      break;
    case 'Premium':
      title = '¡Quiero ser premium plus!';
      break;
    default:
      title = '¡Quiero mejorar mi plan!';
      break;
  }
  return title;
};




const getPeriod = (typePayment) => {
  let title;
  switch (typePayment) {
    case 'oneYear':
      title = 'Anual';
      break;
    case 'sixMonths':
      title = 'Mensual';
      break;
    case 'twelveMonths':
      title = 'Mensual';
      break;
    default:
      title = 'N/A';
      break;
  }
  return title;
};

const getPlan = (typePayment) => {
  let title;
  switch (typePayment) {
    case 'oneYear':
      title = 'Plan anual';
      break;
    case 'sixMonths':
      title = 'Plan mensual';
      break;
    case 'twelveMonths':
      title = 'Plan mensual';
      break;
    default:
      title = '';
      break;
  }
  return title;
};

const benefitsPremiumPlus = [
  {
    image: '/img/profile/my-membership/profile.svg',
    title: 'La mejor visibilidad',
    description:
      'Estarás en los primeros lugares de búsqueda de tu ciudad, no descuides tu calificación.',
  },
  {
    image: '/img/profile/my-membership/marco-visual.svg',
    title: 'Perfil público',
    description:
      'Tener tu perfil público completo te brindará más oportunidades para conseguir clientes.',
  },
  {
    image: '/img/profile/my-membership/clientes.svg',
    title: 'Interacción con clientes',
    description:
      'Interactuar con clientes potenciales te ayudará a generar más oportunidades de negocio.',
  },
];

const benefitsPremium = [
  {
    image: '/img/profile/my-membership/profile.svg',
    title: 'Buen posicionamiento',
    description:
      'Estarás en los primeros lugares de búsqueda de tu ciudad, no descuides tu calificación.',
  },
  {
    image: '/img/profile/my-membership/marco-visual.svg',
    title: 'Perfil público',
    description:
      'Tener tu perfil público completo te brindará más oportunidades para conseguir clientes.',
  },
  {
    image: '/img/profile/my-membership/clientes.svg',
    title: 'Interacción con clientes',
    description:
      'Interactuar con clientes potenciales te ayudará a generar más oportunidades de negocio.',
  },
];

const benefitsFree = [
  {
    image: '/img/profile/my-membership/marco-visual.svg',
    title: 'Perfil público limitado',
    description:
      'Puedes hacer visible en tu perfil datos básicos para posibles clientes',
  },
  {
    image: '/img/profile/my-membership/clientes.svg',
    title: 'Acceso a la comunidad',
    description:
      'Formas parte de la mejor comunidad de abogados para ayudar a posibles clientes',
  },
  {
    image: '/img/profile/my-membership/analytics.svg',
    title: 'Análisis de resultados',
    description:
      'Obtén semanalmente un resumen de las personas que han visitado tu perfil',
  },
];

const getBenefitsCards = (membershipType) => {
  let cards = [];
  switch (membershipType) {
    case 'Free':
      cards = benefitsFree.map((benefit, index) => (
        <CardBenefit
          key={index}
          image={benefit.image}
          className="cards"
          //stylesCard={{ width: 316, height: 'auto', display: 'flex', alignItems: 'center'}}
        >
          <p className="title-18 marine">{benefit.title}</p>
          <p className="text">{benefit.description}</p>
        </CardBenefit>
      ));
      break;
    case 'Premium':
      cards = benefitsPremium.map((benefit, index) => (
        <CardBenefit
          key={index}
          image={benefit.image}
          stylesCard={{ width: 316, height: 272, display: 'flex', alignItems: 'center'}}
        >
          <p className="title-18 marine">{benefit.title}</p>
          <p className="text">{benefit.description}</p>
        </CardBenefit>
      ));

      break;
    case 'Premium Plus':
      cards = benefitsPremiumPlus.map((benefit, index) => (
        <CardBenefit
          key={index}
          image={benefit.image}
          stylesCard={{ width: 316, height: 272, position: 'relative', display: 'flex', alignItems: 'center' }}
          borderTop
        >
          <p className="title-18 marine">{benefit.title}</p>
          <p className="text">{benefit.description}</p>
        </CardBenefit>
      ));

      break;

    default:
      cards = benefitsPremiumPlus.map((benefit, index) => (
        <CardBenefit
          key={index}
          image={benefit.image}
          stylesCard={{ width: 316, height: 272 }}
        >
          <p className="title-18 marine">{benefit.title}</p>
          <p className="text">{benefit.description}</p>
        </CardBenefit>
      ));
      break;
  }
  return cards;
};

const membershipPremiuns = [     {text: <p className='feactures_text'><strong>Incluye todo los beneficios de la membresía Free</strong></p>},
{text: <img className='top-16-0' src='/img/icons/plus-m.svg' alt="icon" />},
{text: <p className='feactures_text'><strong>Perfil profesional</strong> completo y público</p> }, 

{  text: <p className='feactures_text'><strong>Buen posicionamiento</strong> en listados de búsqueda, por detrás de Premium Plus</p>},
{text: <p className='feactures_text'><strong>Chat directo</strong> con los clientes</p>},
{text: <p className='feactures_text'><strong>Cotizaciones en línea</strong> para todos tus clientes</p>},

{text: <p className='feactures_text'>Agrega hasta  <strong>5 colaboradores</strong> de tu despacho</p>},

{text: <p className='feactures_text'>Agrega hasta <strong>2 sedes</strong></p>},
{text: <p className='feactures_text'><strong>Recibe valoraciones de clientes</strong> por los servicios del despacho</p>},
{text: <p className='feactures_text'><strong>Sube imágenes y links de videos</strong> relacionados con tus servicios </p>},
{text: <p className='feactures_text'><strong>Notificaciones</strong> en tiempo real</p>} ]


const membershipPlus = [     {text: <p className='feactures_text'><strong>Incluye todo los beneficios de la membresía Premium</strong></p>},
{text: <img className='top-16-0' src='/img/icons/plus-m.svg' alt="icon" />},
{text: <p className='feactures_text'><strong>El mejor posicionamiento en listados de búsqueda</strong></p> }, 

{  text: <p className='feactures_text'><strong>Distintivo Premium Plus</strong> dentro de los listados</p>},

{  text: <p className='feactures_text'><strong>Perfil abogado Premium</strong> para el titular del despacho</p>},
{text: <p className='feactures_text'><strong>Soporte vía telefónica, WhatsApp o email</strong> por parte de nuestros asesores</p>},
{  text: <p className='feactures_text'>Agrega hasta <strong>10 colaboradores</strong> de tu despacho</p>},
{  text: <p className='feactures_text'>Agrega hasta <strong>5 sedes</strong></p>}]


const Features = ({ role, membership, cardDefault, suscription }) => {
  /* Membership names 
  'premium-plus'
  'premium-plus300'
  'premium'
  'free' */

  const membershipS = {
    type: 'free',
    name: 'Free',
    nextBill: '26/03/2021',
    period: 'semestral',
    amount: '14,268',
    totalAmount: '16,550',
    method: 'Master Card **** **** **** 1234',
  };

  return (
    <div className="features">
      <div className="features-header">
        <div className="features-header-title">
          <p className={`features-header-title-${membership.type}`}>
{/*             <span className="title name">{`Membresía ${membership.type}`}</span>

 */}           
            <span className="title name features-header-type">{`Membresía ${membership.type}`}</span>

  
            <span className="title period">
              {/* {'SEIS MESES GRATIS'} */}
              {membership.type === 'Premium' && membership.gift && membership.gift === '300'
                ? 'SEIS MESES GRATIS'
                : membership.type === 'Free' ? 'Plan gratuito' : ` ${getPlan(membership.typePayment)}`}
            </span>
          </p>
          <span className="features-header-title-active">
            Actualmente {membership.status ? membership.status : 'FREE'}
          </span>
        </div>
        {membership.type === 'Premium' && membership.gift !== '300' ? null : (
          <ButtonBase variant="primary" direction='/membresias-abogados'>
            {getButtonTitle(membership.type)}
          </ButtonBase>
        )}
      </div>

      <div className="features-bill">
        <div className="features-wrap">
          <div className="features-bill-item" style={{ width: 320 }}>
            <p className="features-bill-title">Tu próxima factura</p>
            <p className="features-bill-value">{suscription && suscription.current_period_end ? moment.unix(suscription.current_period_end).utc().format('DD/MM/YYYY'): 'N/A'}</p>
          </div>
          <div
            className="features-bill-item"
            style={{ width: 160, marginRight: 40 }}
          >
            <p className="features-bill-title">Monto membresía</p>
            <p className="features-bill-value">{membership.type ? `$${membership.cost ? membership.cost : '0'}.- MXN` : '$0.- MXN'}</p>
          </div>
          <div
            className="features-bill-item"
            style={{ width: 160, marginRight: 40 }}
          >
            <p className="features-bill-title">Periodo de pago</p>
        <p className="features-bill-value">{getPeriod(membership.typePayment)}</p>
          </div>

          
        </div>

        <div className="features-wrap">
          <div className="features-bill-item" >
            <p className="features-bill-title">Método de pago</p>
            <p className="features-bill-value">{cardDefault && cardDefault.cards && cardDefault.cards.length ?  (`${cardDefault.cards[0].brand} **** **** **** ${cardDefault.cards[0].last4}`) : 'Sin método de pago'}</p>
          </div>
          {/* <div className="features-bill-item">
            <p className="features-bill-title">Monto total</p>
            <p className="features-bill-montoTotal">{membership.type === 'free'?  '$0.- MXN' : `$${membership.totalAmount}.- MXN`}</p>
          </div> */}
        </div>
      </div>

      <section className="features-benefits">
        <p className="title marine">{`Beneficios de tu membresía ${
          membership.type === 'Premium Plus' && membership.gift && membership.gift === '300'
            ? 'Premium Plus gratuita'
            : membership.type === 'Free'
            ? 'gratuita' : (
              membership && membership.type && membership.type.toLowerCase()
            )
        }`}</p>
        <div className="features-flex features-benefits-cards">
          {getBenefitsCards(membership.type)}
        </div>
      </section>

      {membership.type !== 'Free' && (
        <section className="features-moreInfo" style={{marginBottom: membership.type === 'Premium'? 37 : 93}}>
          <p className="title marine">Más acerca de tu membresía</p>
          <div className="features-wrap">
            <List style={{ width: 368, marginRight: 48 }}>
              <ListItem>
                <ListItemIcon>
                  <img src="/img/icons/profile-blue.svg" alt='profile-blue' />
                </ListItemIcon>
                <p className="text">
                  <b>Perfil profesional</b> completo y público
                </p>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <img src="/img/profile/my-membership/billing.svg" alt='billing' />
                </ListItemIcon>
                <p className="text">
                  <b>
                    {membership.type === 'Premium'
                      ? 'Buen posicionamiento'
                      : 'El mejor posicionamiento'}
                  </b>{' '}
                  en listados de búsqueda
                </p>
              </ListItem>
              {membership.type !== 'Premium' && (
                <ListItem>
                  <ListItemIcon>
                    <img src="/img/profile/my-membership/bandera-azul.svg" alt='bandera-azul' />
                  </ListItemIcon>
                  <p className="text">
                    <b>Distintivo</b> Premium Plus <b>dentro de los listados</b>
                  </p>
                </ListItem>
              )}
              <ListItem>
                <ListItemIcon>
                  <img src="/img/profile/my-membership/phone.svg" alt='phone' />
                </ListItemIcon>
                <p className="text">
                  <b>Soporte vía telefónica, WhatsApp o email</b> por parte de
                  nuestros asesores
                </p>
              </ListItem>
              {/* <ListItem>
                <ListItemIcon>
                  <img src="/img/profile/my-membership/chat-1.svg" />
                </ListItemIcon>
                <p className="text">
                  <b>Chat directo</b> con los clientes
                </p>
              </ListItem> */}
            </List>

            <List style={{ width: 368 }}>
              {/* <ListItem>
                <ListItemIcon>
                  <img src="/img/profile/my-membership/historial.svg" />
                </ListItemIcon>
                <p className="text">
                  <b>Cotizaciones en línea</b> para todos tus clientes
                </p>
              </ListItem> */}
              <ListItem>
                <ListItemIcon>
                  <img src="/img/profile/my-membership/active-star.svg" alt='active-star' />
                </ListItemIcon>
                <p className="text">
                  <b>Recibe valoraciones de clientes</b> por tus servicios
                </p>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <img src="/img/profile/my-membership/compartir.svg" alt='compartir' />
                </ListItemIcon>
                <p className="text">
                  <b>Sube imágenes y links de videos relacionados</b> con tus
                  servicios{' '}
                </p>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <img src="/img/profile/my-membership/bell.svg" alt='bell' />
                </ListItemIcon>
                <p className="text">
                  <b>Notificaciones en tiempo real</b>
                </p>
              </ListItem>
            </List>
          </div>
        </section>
      )}

      {membership.type === 'Free' && (
        <section className="features-membershipCards">
          <p className="title marine">Conocer más planes</p>
          <div className="features-membershipCards-container">
            {role === 'lawFirm' && <MFirmsDb />}
            {role === 'lawyer' && <MLawyersDb />}
          </div>
        </section>
      )}

      <section className="features-footer">
        <p>
          Para dudas, sugerencias y cancelaciones llama a nuestro centro de
          customer experience al <b>525541606061</b> o envianos un mail a
          <b> hola@contactaabogado.com</b>
        </p>
      </section>
    </div>
  );
}

const mapStateToProps = state => ({
  role: state.authClient.role,
  membership: state.authClient.membership,
  cardDefault :state.authClient.membershipData,
})

export default connect(mapStateToProps)(Features);
